let promise = {
    abort(){}
};
export default {
    getAllCheckbox({commit, state, getters}, options) {
        let base = {
            url: null,
            params: null
        };

        commit('updateLoadingState', true);
        Object.assign(base, options);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: options.url,
                data: options.params,
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
                commit('updateLoadingState', false);
            })
            .fail((xhr) => {
                reject(xhr);
                console.error('something went wrong', xhr);
                commit('updateLoadingState', false);
            });
        });
    },

    getTableData({commit, state, getters}, options) {
        /**
         * This was originally using a global XHR object that would interfere with the returned promise.
         *
         * That behavior also happens to interfere with the case of 2 vuetables with different vuex-modules
         * loading remote URL's on the same page.
         *
         * The change is to abort the previous promise if the module's isLoading data is true to avoid cross-contamination across modules.
         */
        if (state.isLoading) {
            promise.abort();
        }

        let base = {
            url: null,
            params: null
        };

        const xhr = $.ajax({
            url: options.url,
            data: options.params,
            method: 'GET',
            global: false
        })

        commit('updateLoadingState', true);
        Object.assign(base, options);

        promise = new Promise((resolve, reject) => {
            xhr
            .done((data) => {
                let page = parseInt(data.meta.current_page);

                if (options.useInfinite) {
                    page += 1;
                }
                commit('updateParams', {
                    page: page
                });
                resolve(data);
                commit('updateLoadingState', false);
            })
            .fail((xhr) => {
                reject(xhr);
                console.error('something went wrong', xhr);
                commit('updateLoadingState', false);
            });
        });

        promise.abort = () => {
            xhr.abort();
        }

        return promise;
    },
}